import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-web-development-segovia',
  imports: [RouterLink],
  templateUrl: './web-development-segovia.html',
  styleUrl: '../service-pages.scss',
})
export class WebDevelopmentSegovia {}
